"use strict";
/* globals module */
/**
 * @module commerceProductInstanceFilesBatchClient
 * @description  Product Instance Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../../../httpApi");
var _1 = require("../.././");
var CommerceProductInstanceFilesBatchClient = /** @class */ (function () {
    function CommerceProductInstanceFilesBatchClient(productInstanceFilesBatchRoute, apiClient) {
        this.productInstanceFilesBatchRoute = productInstanceFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductInstanceFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.productInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param productId Product file id of the original product file used to identify product files on which delete action should be performed.
     * @param data Collection of product delete requests which uniquely identifies product files that need to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   productInstanceFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductInstanceFilesBatchClient.prototype.unlink = function (productId, data) {
        return this.apiClient.delete(this.productInstanceFilesBatchRoute.unlink(productId), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param productId Product id which uniquely identifies product whose product file need to be updated.
     * @param data Product file object that need to be updated in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example productInstanceFilesBatchClient.update('<product-id>', files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductInstanceFilesBatchClient.prototype.update = function (productId, data) {
        return this.apiClient.put(this.routeDefinition.update(productId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be linked.
     * @param data A collection of product file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example productInstanceFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductInstanceFilesBatchClient.prototype.link = function (productId, data) {
        return this.apiClient.post(this.routeDefinition.link(productId), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    CommerceProductInstanceFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductInstanceFilesBatchRoute !== "undefined" && _1.CommerceProductInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductInstanceFilesBatchClient);
    return CommerceProductInstanceFilesBatchClient;
}());
exports.CommerceProductInstanceFilesBatchClient = CommerceProductInstanceFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/
